// MOCK DATA (frontend-only). Replace with backend APIs later.

export const siteConfig = {
  brand: {
    name: "Vrinda Homes",
    subname: "Real Estate",
    city: "Gurgaon",
    // Selected from Unsplash by vision agent
    heroImageUrl:
      "https://images.unsplash.com/photo-1559329146-807aff9ff1fb?auto=format&fit=crop&w=2400&q=80",
  },
  contacts: {
    primaryPhone: "7082020985",
    secondaryPhone: "9813245645",
    primaryContactName: "Devansh Garg",
    secondaryContactName: "Kamal Kishor",
    addressLine1: "Shop No. 6, Global City Center",
    addressLine2: "Sec-33, Sohna, Haryana 122103",
    serviceArea: "Gurgaon • Sohna • Nearby Micro-markets",
    whatsapp: "7082020985",
  },
};

export const services = [
  {
    id: "rent",
    title: "Rent (Residential)",
    desc:
      "Verified rental options for families and working professionals—apartments & independent floors in Gurgaon.",
    highlights: ["Verified listings", "Quick move-in", "Transparent terms"],
  },
  {
    id: "sell",
    title: "Buy / Sell (Residential)",
    desc:
      "End-to-end support from shortlisting to documentation—so you buy with confidence or sell faster.",
    highlights: ["Right pricing", "Paperwork support", "Negotiation"],
  },
  {
    id: "plots",
    title: "Plots & Land",
    desc:
      "Plot options across developing pockets—ideal for long-term value and custom builds.",
    highlights: ["Location checks", "Ownership clarity", "Future growth"],
  },
  {
    id: "floors",
    title: "Independent Floors",
    desc:
      "Premium builder floors with privacy—great for upgraded lifestyle and better control than high-rises.",
    highlights: ["Prime sectors", "Quality checks", "Site visits"],
  },
];

export const propertyTypes = [
  {
    id: "independent-floors",
    iconKey: "floors",
    title: "Independent Floors",
    subtitle:
      "More privacy, fewer neighbors, and a premium ‘home-like’ feel—popular across prime sectors.",
    thumbUrl:
      "https://images.pexels.com/photos/17174766/pexels-photo-17174766.jpeg?auto=compress&cs=tinysrgb&w=1200",
    tags: ["Builder floors", "Low-density", "Premium"],
    points: [
      "Prefer sunlight & ventilation? Floors are a strong choice.",
      "Great for families who want privacy + parking clarity.",
      "We help compare construction quality before you decide.",
    ],
  },
  {
    id: "apartments",
    iconKey: "apartment",
    title: "Apartments",
    subtitle:
      "Society living with amenities—ideal for convenience, community and lifestyle features.",
    thumbUrl:
      "https://images.pexels.com/photos/34642280/pexels-photo-34642280.jpeg?auto=compress&cs=tinysrgb&w=1200",
    tags: ["Gated societies", "Amenities", "Security"],
    points: [
      "Shortlist by sector, tower orientation and maintenance.",
      "We coordinate site visits efficiently (same-week possible).",
      "We guide you on rent / resale pricing patterns.",
    ],
  },
  {
    id: "plots",
    iconKey: "plots",
    title: "Plots & Land",
    subtitle:
      "For long-term value or custom-built homes—especially in developing pockets.",
    thumbUrl:
      "https://images.pexels.com/photos/20107811/pexels-photo-20107811.jpeg?auto=compress&cs=tinysrgb&w=1200",
    tags: ["Ownership clarity", "Future growth", "Custom build"],
    points: [
      "We focus on practical checks: access, surroundings, usage.",
      "Get guidance on what to verify before finalizing.",
      "Ideal if you want flexibility and long-term vision.",
    ],
  },
  {
    id: "builder-projects",
    iconKey: "builder",
    title: "Builder Projects",
    subtitle:
      "Exploring inventory near top builders? We help you compare options across pockets.",
    thumbUrl:
      "https://images.pexels.com/photos/31745718/pexels-photo-31745718.jpeg?auto=compress&cs=tinysrgb&w=1200",
    tags: ["M3M", "Godrej", "Central Park"],
    points: [
      "We help you shortlist by location and budget fit.",
      "Compare multiple options in one planned visit schedule.",
      "Clear guidance on next steps and documentation basics.",
    ],
  },
];

export const builders = [
  {
    name: "M3M",
    focus: ["Luxury apartments", "Premium mixed-use"],
    markets: ["Golf Course Ext.", "SPR", "New Gurgaon"],
  },
  {
    name: "Ashiana",
    focus: ["Family communities", "Kid-centric living"],
    markets: ["Sohna Road", "Sector clusters"],
  },
  {
    name: "Godrej Properties",
    focus: ["Lifestyle projects", "Green design"],
    markets: ["Golf Course Ext.", "Sector 49", "New Gurgaon"],
  },
  {
    name: "Central Park",
    focus: ["Resort living", "Premium towers"],
    markets: ["Sohna Road", "Sector 48 vicinity"],
  },
  {
    name: "Birla Estates",
    focus: ["Contemporary homes", "Premium amenities"],
    markets: ["NCR corridors", "Select sectors"],
  },
];

// NOTE: Public internet sources differ on sizes/pricing/possession. These are indicative.
export const featuredProjects = [
  {
    id: "m3m-antalya",
    builder: "M3M",
    name: "M3M Antalya (Antalya Hills)",
    type: "Low-rise / Independent Floors",
    location: "Sector 79, Gurugram",
    config: "2.5 & 3.5 BHK",
    sizeRange: "~1100–1600 sq.ft.*",
    startingPrice: "~₹2 Cr onwards*",
    priceNote: "Pricing varies",
    highlights: ["Aravalli edge", "Low-density living", "Club amenities"],
    amenities: ["Swimming pool", "Gym", "Jogging track", "Sports courts"],
    possession: "As per developer/RERA timeline*",
    rera: "Multiple phases (check latest RERA)*",
    connectivity: ["NH-8", "SPR", "Dwarka Expressway", "KMP"],
    imageUrl:
      "https://d2dy9w7mmecm6m.cloudfront.net/dy-images/residential/ProjectImage/about_1_-_kCswib6RHGxG_-_EVnEhPbMR3X3.jpg",
    galleryUrls: [
      "https://d2dy9w7mmecm6m.cloudfront.net/dy-images/residential/ProjectImage/about_1_-_kCswib6RHGxG_-_EVnEhPbMR3X3.jpg",
      "https://d2dy9w7mmecm6m.cloudfront.net/dy-images/residential/GlimpsesOfMasterpiece/1_-_0Cj0ENTe8AMC.jpg",
      "https://d2dy9w7mmecm6m.cloudfront.net/dy-images/residential/GlimpsesOfMasterpiece/2_-_vO5L3juH0jmd.jpg",
      "https://d2dy9w7mmecm6m.cloudfront.net/dy-images/residential/GlimpsesOfMasterpiece/3_-_0qFEDtsvOQ6s.jpg",
    ],
  },
  {
    id: "ashiana-anmol",
    builder: "Ashiana",
    name: "Ashiana Anmol",
    type: "Apartments / Community Living",
    location: "Sector 33, Sohna (South Gurugram)",
    config: "2 & 3 BHK",
    sizeRange: "~780–1880 sq.ft.*",
    startingPrice: "~₹1.3 Cr onwards*",
    priceNote: "Depends on unit",
    highlights: ["Family-friendly", "Clubhouse", "Sports facilities"],
    amenities: ["33,000 sq.ft clubhouse*", "Kids’ zones", "Sports courts", "Power backup"],
    possession: "~Apr 2026 onwards*",
    rera: "As per Haryana RERA listing*",
    connectivity: ["Sohna Road", "SPR", "Golf Course Ext.", "Schools/Hospitals"],
    imageUrl:
      "https://www.ashianahousing.com/uploads/gallery/D1-1632221461.webp",
    // Selected from official Ashiana page assets. Avoids unrelated visuals.
    galleryUrls: [
      "https://www.ashianahousing.com/uploads/property/anmol-banner-desk-1661538851.webp",
      "https://www.ashianahousing.com/uploads/gallery/D1-1632221461.webp",
      "https://www.ashianahousing.com/uploads/gallery/D3-1632222022.webp",
      "https://www.ashianahousing.com/photos/550x300/property/550x300-1679462331.jpg",
    ],
  },
  {
    id: "godrej-aristocrat",
    builder: "Godrej",
    name: "Godrej Aristocrat",
    type: "Luxury High-rise",
    location: "Sector 49, Gurugram",
    config: "3 & 4 BHK",
    sizeRange: "~1600–3800 sq.ft.*",
    startingPrice: "~₹3.4 Cr onwards*",
    priceNote: "Premium segment",
    highlights: ["Luxury clubhouse", "Green concept", "High-rise towers"],
    amenities: ["Forest clubhouse*", "Fitness & spa", "Sports courts", "Smart living"],
    possession: "~2030 onwards*",
    rera: "GGM/767/499/2023/111*",
    connectivity: ["Golf Course Ext.", "SPR", "Sohna Road", "Key hubs"],
    imageUrl:
      "https://www.godrejgroupsindia.com/project_pics/godrej-aristocrat-gurgaon-banner-15275.jpg",
    galleryUrls: [
      "https://www.godrejgroupsindia.com/project_pics/godrej-aristocrat-gurgaon-banner-15275.jpg",
    ],
  },
];

export const testimonials = [
  {
    name: "Rohit S.",
    title: "Tenant, Sector 67",
    quote:
      "Vrinda Homes shortlisted genuine options quickly and handled everything smoothly. I moved in within a week.",
  },
  {
    name: "Nikita G.",
    title: "Buyer, Sohna",
    quote:
      "They explained market pricing clearly and kept paperwork stress-free. The site visit planning was on point.",
  },
  {
    name: "Aman K.",
    title: "Owner, Sector 57",
    quote:
      "My property got the right tenant fast. Communication was consistent and professional.",
  },
];

export const faqs = [
  {
    q: "Which locations do you cover in Gurgaon?",
    a: "We focus on Gurgaon & nearby micro-markets like Sohna. Share your preferred sector / budget and we’ll shortlist options accordingly.",
  },
  {
    q: "Do you help with documentation and agreement support?",
    a: "Yes. We coordinate required documents, agreement basics, and help you stay clear on terms and timelines.",
  },
  {
    q: "Can you arrange site visits on weekends?",
    a: "Absolutely. Share your availability and we’ll plan a tight schedule so you can compare multiple options in one go.",
  },
  {
    q: "How do I get started?",
    a: "Just submit an enquiry with your requirement (rent/buy/plot/floor). We’ll call back and share a shortlist.",
  },
];
